// maintenance-gate.js
export function createMaintenanceGate(endpoint = '/CouponApiByT/getMaintainModeMessage', timeoutMs = 2000) {
  function fetchWithTimeout(url, ms) {
    return new Promise((resolve, reject) => { //eslint-disable-line
      const ctl = new AbortController();
      const id = setTimeout(() => ctl.abort(), ms);
      fetch(url, { signal: ctl.signal })
        .then(res => res.text())
        .then(txt => {
          const msg = txt.trim();
          const isMaint = msg.length > 0; // 有文字 = 維護模式
          resolve({ isMaint, message: msg });
        })
        .catch(() => {
          // 呼叫失敗，直接當作「正常模式」
          resolve({ isMaint: false, message: '' });
        })
        .finally(() => clearTimeout(id));
    });
  }

  async function check() {
    return await fetchWithTimeout(endpoint, timeoutMs);
  }

  return { check };
}
